<template>
  <div class="help_item">
    <div class="header_container">
      <div class="share_info">
        <div class="share_profile">
          <img
            :src="
              data.headImage ||
              defaultHeadPortrait
            "
            alt=""
          />
          <div class="share_name">
            <p class="share_name_school ellipsis">{{ data.schoolName }}</p>
            <p class="share_name_club ellipsis">{{ data.groupName }}</p>
          </div>
        </div>
        <img class="share_icon" src="@/assets/help-activity/icon@2x.png" />
      </div>
      <div class="match-picture">
        <img :src="data.groupImage" />
      </div>
      <p class="manifesto_container">{{ data.sendContent }}</p>
      <div class="manifesto_container">
        <div class="like_btn" v-show="!data.isGiveLike" @click="giveLike">
          <img src="@/assets/help-activity/like@2x.png" v-show="!data.giveLikeGif" />
          <img class="like_gif" src="@/assets/help-activity/like_gif.gif" v-show="data.giveLikeGif" />
          <div class="gif_placeholder" v-show="data.giveLikeGif"></div>
          <span style="padding-left: 25px;">点赞</span>
        </div>
        <div class="like_btn has_like_btn" v-show="data.isGiveLike">
          <img style="width: 15px;" src="@/assets/help-activity/liked@2x.png" />
          <span style="padding-left: 25px;">已赞</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { giveLike } from "@/api";
export default {
  props: ['data', 'giveLikeCount'],
  data () {
    return {
      defaultHeadPortrait: require('@/assets/help-activity/photo3@2x.png'),
    }
  },
  methods: {
    async giveLike () {
      console.log('HelpItem', this.giveLikeCount);
      if (this.giveLikeCount === 0) {
        this.$emit('hasNotLikeNum'); // 没有点赞数
        return;
      }
      if (this.data.giveLikeGif) {
        return; // 防快速连点
      }
      this.$emit('hasLike', this.data);
      if (this.giveLikeCount > 0) {
        const postData = {
          taskSenderId: this.data.id,
        };
        const res = await giveLike(postData);
      }
    },
  }
};
</script>
<style lang="less" scope>
.help_item {
  display: flex;
  flex-direction: column;
  .header_container {
    background: #fff;
    padding: 15px;
    border-radius: 8px;
  }
  .share_info {
    padding: 0 0 15px;
    font-size: 16px;
    color: #274A9B;
    font-family: 'FZSHUIY_CUJW--GB1-0', 'FZSHUIY_CUJW--GB1';
    display: flex;
    justify-content: space-between;
    align-items: center;
    .share_icon {
      width: 30px;
      height: 20px;
    }
    .share_profile {
      display: flex;
      align-items: center;
      flex: 1;
      width: 0;
      .share_name {
        padding-left: 15px;
        flex: 1;
        width: 0;
        .share_name_school {
          font-size: 15px;
          font-weight: bold;
        }
        .share_name_club {
          font-size: 13px;
        }
      }
      img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
    }
  }
  .match-picture {
    // height: 100vw * 196 / 375;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .manifesto_container {
    padding: 10px 0;
    line-height: 20px;
    font-size: 11px;
    word-break: break-all;
  }
  .manifesto_container {
    display: flex;
    justify-content: space-between;
    div {
      height: 38px;
      line-height: 38px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      letter-spacing: 1.5px;
    }
    .like_btn {
      flex: 1;
      background: linear-gradient(133deg, #65C7FD 0%, #6662FF 100%);
      border-radius: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        position: absolute;
        width: 16px;
        transform: translateX(-17.5px);
        // margin-right: 6px;
        // margin-left: 36vw;
      }
      .like_gif {
        position: absolute;
        top: -28.5px;
        // left: 50%;
        // transform: translate(calc(-50% - 20px), calc(-50% - 3px));
        transform: translateX(-17px);
        width: 95px;
        margin-left: 0;
      }
      .gif_placeholder {
        position: absolute;
        width: 16px;
        // margin-left: 36vw;
        margin-right: 6px;
      }
    }
    .has_like_btn {
      background: #DDE0E9;
      color: #fff;
    }
  }
}
</style>
